import http from '../http-common'

const types = () => {
 return http.get('/billing-account-types')
}


export const billingTypesService = {
    types
}